import { PublicItineraryDatasource } from "@beneficiary/data/datasource/public-itinerary.datasource";
import { CreatePublicItinerary } from "@beneficiary/domain/models/public-itinerary/create-public-itinerary.model";
import { EditPublicItinerary } from "@beneficiary/domain/models/public-itinerary/edit-public-itinerary.model";
import {
    PublicItineraries,
    PublicItinerary,
} from "@beneficiary/domain/models/public-itinerary/public-itinerary.model";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { ValidationError } from "@core/domain/errors/validation.error";
import { Pagination } from "@core/domain/models/pagination";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class PublicItineraryRepository {
    constructor(
        @inject(PublicItineraryDatasource)
        private readonly publicItineraryDatasource: PublicItineraryDatasource,
    ) {}

    async getAllBy(
        beneficiaryId: number,
        pagination: Pagination,
    ): Promise<Either<FallbackError, PublicItineraries>> {
        return this.publicItineraryDatasource.fetchAllBy(
            beneficiaryId,
            pagination,
        );
    }

    async create(
        publicItinerary: CreatePublicItinerary,
    ): Promise<Either<ValidationError | FallbackError, PublicItinerary>> {
        return this.publicItineraryDatasource.create(publicItinerary);
    }

    async edit(
        editPublicItinerary: EditPublicItinerary,
    ): Promise<Either<ValidationError | FallbackError, PublicItinerary>> {
        return this.publicItineraryDatasource.edit(editPublicItinerary);
    }

    async delete(
        publicItineraryId: number,
    ): Promise<Either<FallbackError, boolean>> {
        return this.publicItineraryDatasource.delete(publicItineraryId);
    }
}
